import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=2927bd92&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=2927bd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927bd92",
  null
  
)

export default component.exports